import { GridApi, IRowNode } from 'ag-grid-community'

export const getAllVisibleLeafNodes = (api: GridApi): IRowNode[] => {
  const nodes: IRowNode[] = []
  api.forEachNodeAfterFilter(n => {
    if (!n.group) {
      nodes.push(n)
    }
  })
  return nodes
}

export const getVisibleLeafChildren = (api: GridApi, node: IRowNode): IRowNode[] => {
  const allVisible = getAllVisibleLeafNodes(api)
  return node.allLeafChildren?.filter(curr => allVisible.includes(curr)) ?? []
}
